"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TO = exports.FROM = void 0;
exports.FROM = 'from';
exports.TO = 'to';
//# sourceMappingURL=types.js.map